export const cirbState = {
  selectedCirb: {},
  selectedIndex: null,
  protocol: {},
  getProtocolApproval: {},
  // getSyncVersion: {},
  protocolApprovalDetails: {},
  protocolVersions: []
};

export const institutionDetailsState = {
  siteDetails: {}
};

export const cirbAddtionalDetailsState = {
  missingPref: [],
  siteEvents: [],
  signatoryContacts: [],
  siteApprovals: [],
  duplicateEvents: [],
  eventsHistory: [],
  isLoadingAdditionalDetails: false
};

export const capProcessingQueue = {
  queuedList: [],
  isCheckForQueuedItems: false
};
